<div class="auth-field" [formGroup]="form">
  <label i18n>
    {method, select, idNumber {מספר תעודת זהות} passport {מספר דרכון}}
  </label>

  <div class="auth-input-wrap auth-input-wrap--no-icon">
    <input
      *ngIf="method === identifyMethod.IdNumber"
      class="auth-input auth-input--with-toggle auth-input--identity-key"
      type="text"
      required
      formControlName="key"
      [autofocus]="loadState"
      maxlength="9"
      autocomplete="username"
      inputmode="numeric"
      pattern="[0-9]{9}"
      placeholder="הזינו 9 ספרות"
      i18n-placeholder
      (input)="onIdNumberInput($event)"
    />

    <input
      *ngIf="method === identifyMethod.Passport"
      class="auth-input auth-input--with-toggle auth-input--identity-key"
      type="text"
      required
      formControlName="key"
      [autofocus]="loadState"
      maxlength="10"
      autocomplete="username"
      placeholder="הזינו מספר דרכון"
      i18n-placeholder
    />

    <div class="auth-id-toggle" role="group" aria-label="סוג זיהוי" i18n-aria-label>
      <button
        type="button"
        [class.is-active]="method === identifyMethod.IdNumber"
        [attr.aria-pressed]="method === identifyMethod.IdNumber"
        (click)="setMethod(identifyMethod.IdNumber)"
      >
        <mat-icon *ngIf="method === identifyMethod.IdNumber">check</mat-icon>
        <span i18n>ת.ז.</span>
      </button>
      <button
        type="button"
        [class.is-active]="method === identifyMethod.Passport"
        [attr.aria-pressed]="method === identifyMethod.Passport"
        (click)="setMethod(identifyMethod.Passport)"
      >
        <mat-icon *ngIf="method === identifyMethod.Passport">check</mat-icon>
        <span i18n>דרכון</span>
      </button>
    </div>
  </div>

  <ng-content select="[identityKeyHint]"></ng-content>

  <div class="auth-field__feedback" aria-live="polite">
    <p class="auth-field-error" *ngIf="showKeyError" i18n>
      אנא הזן מספר {method, select, idNumber {תעודת זהות} passport {דרכון}} תקין
    </p>
  </div>
</div>
